import { TableSortLabel } from '@mui/material';
import type { Column } from '@tanstack/react-table';

interface SortProps {
  column: Column<any>;
}
export const Sort = ({ column }: SortProps) => {
  if (!column.getCanSort()) {
    return null;
  }

  return (
    <TableSortLabel
      active={column.getIsSorted() !== false}
      direction={column.getIsSorted() === 'desc' ? 'desc' : 'asc'}
    />
  );
};
